import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 
 */
export class HelpControllerSvr {
    constructor() {
        this.baseurl = 'HelpControllerSvr.assx/';
    }

    /**
     * 获取文档
     * type:String
     */
    getDocListFromHmfs(type){
        return request.post(this.baseurl + 'getDocListFromHmfs', Qs.stringify({ type:type }));
    }

    /**
     * 添加手册配置
     * docId:String, docTitle:String, docType:String, docUrl:String, roles:String
     */
    addDocConfiguration(docId, docTitle, docType, docUrl, roles){
        return request.post(this.baseurl + 'addDocConfiguration', Qs.stringify({ docId:docId, docTitle:docTitle, docType:docType, docUrl:docUrl, roles:roles }));
    }

    /**
     * 获取手册配置信息
     * token:String, id:String
     */
    getDocConfigDetail(token, id){
        return request.post(this.baseurl + 'getDocConfigDetail', Qs.stringify({ token:token, id:id }));
    }

    /**
     * 删除手册配置
     * id:String
     */
    deleteDocConfiguration(id){
        return request.post(this.baseurl + 'deleteDocConfiguration', Qs.stringify({ id:id }));
    }

    /**
     * 获取手册配置列表
     * token:String, start:int, size:int
     */
    getDocConfigurations(token, start, size){
        return request.post(this.baseurl + 'getDocConfigurations', Qs.stringify({ token:token, start:start, size:size }));
    }

    /**
     * 获取文档内容
     * docId:String
     */
    getDocContent(docId){
        return request.post(this.baseurl + 'getDocContent', Qs.stringify({ docId:docId }));
    }

    /**
     * 更新手册配置
     * id:String, docId:String, docTitle:String, docType:String, docUrl:String, roles:String
     */
    editDocConfiguration(id, docId, docTitle, docType, docUrl, roles){
        return request.post(this.baseurl + 'editDocConfiguration', Qs.stringify({ id:id, docId:docId, docTitle:docTitle, docType:docType, docUrl:docUrl, roles:roles }));
    }

    /**
     * 根据角色获取手册列表
     * token:String
     */
    getDocList(token){
        return request.post(this.baseurl + 'getDocList', Qs.stringify({ token:token }));
    }
}